import EmblaCarousel from "embla-carousel";

/**
 * Initialize Embla carousel
 */
export function initCarousel() {
	const emblaNodes = document.querySelectorAll(".embla");

	emblaNodes.forEach((emblaNode) => {
		const options = {
			align: "start",
			duration: 20,
			loop: true,
		};
		const emblaApi = EmblaCarousel(emblaNode, options);

		// Get navigation buttons
		const prevButton = emblaNode.querySelector(".embla__prev");
		const nextButton = emblaNode.querySelector(".embla__next");

		// Add event listeners for navigation
		if (prevButton) {
			prevButton.addEventListener("click", () => {
				emblaApi.scrollPrev();
			});
		}

		if (nextButton) {
			nextButton.addEventListener("click", () => {
				emblaApi.scrollNext();
			});
		}

		// Update button states based on current slide
		const updateButtons = () => {
			if (prevButton) {
				prevButton.disabled = !emblaApi.canScrollPrev();
			}
			if (nextButton) {
				nextButton.disabled = !emblaApi.canScrollNext();
			}
		};

		// Update buttons on slide change (if not using loop)
		if (!options.loop) {
			emblaApi.on("select", updateButtons);
			updateButtons(); // Initial state
		}

		// console.log(emblaApi.slideNodes()); // Access API
	});
}
